/* eslint-disable react-hooks/exhaustive-deps */
import { CircularProgress, Grid } from "@mui/material";
import {
  getGeoInfo,
  swalError,
  swalSuccess,
  swalWarning,
} from "@unisearch/helpers";
import API from "@unisearch/helpers/api";
import { authAtom } from "@_recoil/_state";
import { Field, Form, Formik } from "formik";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import * as Yup from "yup";
import PhoneInput from "react-phone-input-2";
import styles from "./contact_us_form.module.scss";
import Cookies from "js-cookie";

export const ContactusForm = ({
  formFor,
  universityId,
  uniProfileData,
  ...props
}) => {
  const init = {
    parentMessageId: undefined,
    message_id: "",
    message: "",
    senderType: "",
    senderId: undefined,
    senderName: "",
    senderEmail: "",
    senderPhone: "",
    subject: "",
    universityId: undefined,
  };
  const [loadingState, setLoadingState] = useState(false);
  const profileInfo = useRecoilValue(authAtom);
  const [initialState, setInitialState] = useState(init);
  const [disable, setDisable] = useState(false);

  const [defaultCountryCode, setDefaultCountryCode] = useState("in");
  useEffect(() => {
    setTimeout(() => {
      if (Cookies.get("default_country")) {
        setDefaultCountryCode(Cookies.get("default_country"));
      }
    }, 1500);
  }, [defaultCountryCode]);

  // form validation rules
  const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const validationSchema = Yup.object().shape({
    senderName: Yup.string().required("Name is required"),
    senderEmail: Yup.string()
      .email()
      .typeError("Please provide valid email")
      .required("Field is required"),
    subject: Yup.string().required("Subject is required"),
    message: Yup.string().required("Please type your message"),
    terms_and_condition: Yup.boolean().oneOf(
      [true],
      "You must accept the terms and conditions"
    ),
  });

  const isFormEnable = (values, errors = false) => {
    if (
      errors &&
      Object.keys(errors).length == 0 &&
      values?.terms_and_condition
    ) {
      return false;
    } else {
      return true;
    }
  };

  const SubmitQuery = async (values, actions) => {
    setLoadingState(true);
    delete values.terms_and_condition;
    let payload = {
      ...values,
      parentMessageId: 0,
      universityId: universityId,
    };

    if (
      profileInfo &&
      profileInfo?.userTypeSlug &&
      profileInfo?.userTypeSlug === "university"
    ) {
      setLoadingState(false);
      return swalWarning("University user not able to send message", "Sorry");
    } else if (profileInfo?.userTypeSlug && profileInfo?.id) {
      (payload.senderType = profileInfo?.userTypeSlug),
        (payload.senderId = profileInfo?.id);
    } else {
      (payload.senderType = "guest"), (payload.senderId = 0);
    }
    try {
      let API_ENDPOINT = `public/university-conversation`;
      await API.post(API_ENDPOINT, payload).then((resp) => {
        if (resp.error) {
          swalError("Something went wrong");
          setLoadingState(false);
        }
        if (!resp.error) {
          actions.resetForm();
          swalSuccess("Messege send successfully");
          setLoadingState(false);
        }
      });
      setLoadingState(false);
    } catch (error) {
      setLoadingState(false);
      swalError("Something went wrong");
    }
  };

  useEffect(() => {
    if (
      profileInfo?.userTypeSlug &&
      profileInfo?.userTypeSlug !== "university"
    ) {
      const payload = {
        senderName: `${profileInfo?.firstName} ${profileInfo?.middleName} ${profileInfo?.lastName}`,
        senderEmail: profileInfo?.email,
        senderPhone: profileInfo?.mobile ? profileInfo?.mobile : "",
      };
      setDisable(true);
      setInitialState(payload);
    } else {
      setDisable(false);
      setInitialState(init);
    }
  }, [profileInfo]);

  return (
    <div className={styles.form_wrapper}>
      <Formik
        initialValues={initialState}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={(values, actions) => {
          SubmitQuery({ ...values }, actions);
        }}
      >
        {({ handleSubmit, values, errors, touched, setFieldValue }) => (
          <Form className="form">
            <h2 className={styles.title}>Send Us a Message</h2>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={12} md={6}>
                <div className={styles.form_group}>
                  <label>
                    Name <span className={"asterisk"}> *</span>
                  </label>
                  <input
                    type="text"
                    name="senderName"
                    placeholder="Type Your Name"
                    disabled={disable}
                    onChange={(e) => {
                      setFieldValue("senderName", e.target.value);
                    }}
                    value={values.senderName ?? ""}
                  />
                  {errors.senderName && touched.senderName ? (
                    <div className="invalid-feedback">{errors.senderName}</div>
                  ) : null}
                </div>
              </Grid>

              <Grid item xs={12} sm={12} md={6}>
                <div className={styles.form_group}>
                  <label>
                    Email Address <span className={"asterisk"}> *</span>
                  </label>
                  <Field
                    type="email"
                    name="senderEmail"
                    placeholder="Type Your Email"
                    disabled={disable}
                  />
                  {errors.senderEmail && touched.senderEmail ? (
                    <div className="invalid-feedback">{errors.senderEmail}</div>
                  ) : null}
                </div>
              </Grid>

              <Grid item xs={12} sm={12} md={6}>
                <div className={styles.form_group}>
                  <label>
                    Message Subject <span className={"asterisk"}> *</span>
                  </label>
                  <Field
                    type="text"
                    name="subject"
                    placeholder="Type Message Subject"
                    value={values.subject ?? ""}
                  />
                  {errors.subject && touched.subject ? (
                    <div className="invalid-feedback">{errors.subject}</div>
                  ) : null}
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <div className={styles.form_group}>
                  <label>Mobile Number</label>
                  <PhoneInput
                    placeholder="Mobile Number"
                    country={defaultCountryCode ?? "in"}
                    countryCodeEditable={false}
                    value={values.senderPhone ?? ""}
                    onChange={(_value, _country, _event, formattedValue) => {
                      setFieldValue("senderPhone", formattedValue);
                    }}
                    name={"senderPhone"}
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={styles.form_group}>
                  <label>
                    Your Message <span className={"asterisk"}> *</span>
                  </label>
                  <Field
                    as="textarea"
                    name="message"
                    placeholder="Type Your Message"
                    value={values.message ?? ""}
                  />
                  {errors.message && touched.message ? (
                    <div className="invalid-feedback">{errors.message}</div>
                  ) : null}
                </div>
              </Grid>
            </Grid>

            <div className={styles.checkbox_container_wrapper}>
              <div className={styles.checkbox_with_error_wrapper}>
                <div className={styles.checkbox_wrapper}>
                  <label
                    className={`${styles.checkbox_lebel} checkbox_container`}
                    html="terms"
                  >
                    <Field
                      id="terms"
                      type="checkbox"
                      name="terms_and_condition"
                      className="checkbox disable-team team_values"
                      value={true}
                      checked={
                        values.terms_and_condition &&
                        values.terms_and_condition === true
                          ? true
                          : false
                      }
                      onChange={(event) => {
                        setFieldValue(
                          "terms_and_condition",
                          event.target.checked
                        );
                        touched.terms_and_condition = true;
                      }}
                    />
                    <span
                      className="checkbox_checkmark"
                      style={{ marginLeft: "0px", marginTop: "2px" }}
                    ></span>
                    <span>I agree to UniSearch</span>
                  </label>

                  <Link legacyBehavior href="/terms-and-conditions">
                    <a className={styles.term_link}>Terms</a>
                  </Link>
                  <span>and</span>
                  <Link legacyBehavior href="/privacy-policy">
                    <a className={styles.term_link}>Privacy Policy.</a>
                  </Link>
                </div>

                {errors?.terms_and_condition && touched?.terms_and_condition ? (
                  <div className={styles.error_msg}>
                    {errors.terms_and_condition}
                  </div>
                ) : null}
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-secondary btn-bg btn-full btn-secondary-box-shadow"
              onClick={handleSubmit}
              disabled={
                loadingState || isFormEnable(values, errors) ? true : false
              }
            >
              {loadingState && <CircularProgress size="20px" color="inherit" />}{" "}
              Send Message
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ContactusForm;
